module.exports = __webpack_public_path__ + "img/4.61a2a4b5.jpg";